import { Component, Input } from '@angular/core';
import { BaseGridComponent } from 'projects/libraries/syslink-components/src/lib/grid/base-grid/base-grid.component';
import { StockMoveIncomingLine } from '../stock-move-incoming-line.model';
import { SelectDescriptor } from 'devextreme/data';
import { SyslinkColumn } from 'projects/libraries/syslink-components/src/lib/helpers/SyslinkColumn';
import { StockMoveIncomingLinesService } from '../stock-move-incoming-lines.service';

@Component({
  selector: 'app-stock-move-incoming-lines-grid',
  templateUrl: './stock-move-incoming-lines-grid.component.html',
  styleUrls: ['./stock-move-incoming-lines-grid.component.scss']
})
export class StockMoveIncomingLinesGridComponent extends BaseGridComponent<StockMoveIncomingLine> {

  @Input() override storageKey: string = 'stock-move-incoming-lines';
  @Input() public override expand?: string | string[] = ["HeaderId.CurrentStatusLink.StatusId", "ToStockLocationId"];
  @Input() public override select?: SelectDescriptor<any> = ['Id','Quantity'];

  public columns: SyslinkColumn[] = [
    new SyslinkColumn({ field: 'HeaderId.No', label: 'No', sortable: true, sortIndex: 0, sortDirection: 'desc' }),
    new SyslinkColumn({ field: 'Quantity', label: 'Quantity', type:"number"}),
    new SyslinkColumn({ field: 'HeaderId.Date', label: 'Date', type:"date"}),   
    new SyslinkColumn({ field: 'ToStockLocationId.Name', label: 'StockMoveCustomerIncoming.StockLocation'}),   
 ];

  constructor(
    public stockMoveIncomingLinesService: StockMoveIncomingLinesService,
  ) {
    super();
  }
}